var render, staticRenderFns
import script from "./BaseTable.vue?vue&type=script&lang=ts&"
export * from "./BaseTable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=2e8a00d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports